import { useMsal } from "@azure/msal-react";
import { PrimaryButton } from "@fluentui/react";
import { signOutActiveUser } from "../shared/authConfig";

const LogoutButton = () => {
  const { instance } = useMsal();

  return (
    <PrimaryButton
      onClick={() => {
        signOutActiveUser(instance);
      }}
      text="Sign Out"
    />
  );
};

export default LogoutButton;
